import React from 'react'
import { Button, Container, Row, Card, Col, Tabs, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from './Measures.module.scss';
import { data } from '../data';

const PSIResources = () => {

    return (<>
        <Container className='outerContainer'>
            <h1 className="centerText mb-5">Patient Safety Indicators Overview</h1>
            <h3>What are Patient Safety Indicators?</h3>
            <p>The Patient Safety Indicators (PSIs) provide information on potentially avoidable safety events that represent opportunities for improvement in the delivery of care. More specifically, they focus on potential in-hospital complications and adverse events following surgeries, procedures, and childbirth.</p>
            <h3>How are Patient Safety Indicators used?</h3>
            <p>The PSIs can be used to help hospitals assess the incidence of adverse events and in-hospital complications and identify issues that might need further study.</p>
            <p>For more information about the Prevention Quality Indicators, download the <a href='https://www.qualityindicators.ahrq.gov/Downloads/Modules/PSI/V50/PSI_Brochure.pdf'>Patient Safety Indicators Brochure</a>.</p>
        </Container>
        <Container className='outerContainer'>
            <h1 className="centerText mb-5">Patient Safety Indicators Resources</h1>
            {data.PSI.map((information, index) => (
                <div key={index}>
                    <Tabs defaultActiveKey="technical" className={'qiTabs'}>
                        <Tab id="techspecs" eventKey="technical" title="Technical Specifications">
                            <Container className='outerContainer'>
                                <Row>
                                    {information.technical && information.technical.map(info => (
                                        <Col className={styles.columns} xs={12} sm={6} md={4}>
                                            <Card className={styles.cards}>
                                                <Card.Header className={styles.cardHeader} >
                                                    <a href={info.url}><h5>{info.title}</h5></a>
                                                </Card.Header>
                                                <Card.Body className={styles.lightGrey}>
                                                    <Card.Text>
                                                        {info.desc}
                                                        {info.status === "new" ? <span class='new-label'> -New!</span> :null}

                                                    </Card.Text>
                                                </Card.Body>
                                                <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                                                    <Button className={styles.ctaBtn} href={info.url}>{info.cta}</Button>
                                                </div>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Container>

                        </Tab>
                        <Tab eventKey="additional" title="Additional PSI Resources">
                            <Container className='outerContainer'>
                                <Row>
                                    {information.additional && information.additional.map(info => (<>
                                        <Col className={styles.columns} xs={12} sm={6} md={4}>
                                            <Card className={styles.cards}>
                                                <Card.Header className={styles.cardHeader} >
                                                    <a href={info.url}><h5>{info.title}</h5></a>
                                                </Card.Header>
                                                <Card.Body className={styles.lightGrey}>
                                                    <Card.Text>
                                                        <div dangerouslySetInnerHTML={{ __html: info.desc }} />
                                                        {info.status === "new" ? <span class='new-label'> -New!</span> :null}

                                                    </Card.Text>
                                                </Card.Body>
                                                <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                                                    <Button className={styles.ctaBtn} href={info.url}>View</Button>
                                                </div>
                                            </Card>
                                        </Col>
                                    </>)
                                    )}
                                </Row>

                            </Container>
                        </Tab>

                    </Tabs>
                    <p>To access prior versions of the PSI resources, visit the <Link to="/archive/qi_modules?3#PSI-TechSpec">Archives page</Link></p>

                </div>
            )
            )}
        </Container>
        <Container className='outerContainer'>
            <h3>Quality Indicator Software</h3>
            <p>Visit the  <Link to="/software">AHRQ QI Software Page</Link>  for more information on the Quality Indicators SAS QI and WinQI software.</p>
        </Container>
    </>)
}

export default PSIResources;